<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :expandedOptions="{
                enabled: true,
                template: 'call-stats-details',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Called Numbers",

        userBranch: "",
        url: "",

        fromDate: "",
        toDate: "",

        actions: [],
        columns: [
            {
                label: "Number",
                field: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Calls",
                field: "callsCount",
                visible: true,
                type: "number",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Callers",
                field: "familiesCalling",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Blocked",
                field: "callsBlocked",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "In",
                field: "callsIn",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Out",
                field: "callsOut",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.fromDate = toISOLocal(
                new Date(moment().subtract(3, "days"))
            ).substr(0, 10);
            this.toDate = toISOLocal(new Date(moment().add(1, "days"))).substr(
                0,
                10
            );

            this.actions.push({
                text: "From Date",
                type: "datepicker",
                value: this.fromDate,
                action: this.onFromDateChanged,
                align: "left",
            });

            this.actions.push({
                text: "To Date",
                type: "datepicker",
                value: this.toDate,
                action: this.onToDateChanged,
                align: "left",
            });

            this.url =
                "campCallsReport?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;
        },
        onFromDateChanged(value) {
            this.fromDate = value;

            this.url =
                "campCallsReport?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onToDateChanged(value) {
            this.toDate = value;

            this.url =
                "campCallsReport?fromDate=" +
                this.fromDate +
                "&toDate=" +
                this.toDate;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async onRowClicked(call) {},
    },
};
</script>
<style></style>
